import React, { useState } from 'react';

import { useApp } from '@playbooks/contexts';
import { useMounted } from '@playbooks/hooks';

type ProjectLayoutContext = {
	options: any;
	setOptions: any;
};

export const ProjectLayoutContext = React.createContext<ProjectLayoutContext>(null);

const PROJECT_SIDEBAR_WIDTH = 384;
const PROJECT_SIDEBAR_COLLAPSED_WIDTH = 0;
const PROJECT_SIDEBAR_SNAP_WIDTH = 180;

const ProjectLayoutProvider = ({ projectId, children }) => {
	const [options, setOptions] = useState({
		sidebar: true,
		sidebarWidth: PROJECT_SIDEBAR_WIDTH,
		sidebarView: 'messages',
		checkpoint: null,
	});
	const app = useApp();

	// Hooks
	useMounted(() => {
		setOptions(current => ({ ...current, sidebar: app.size.md, sidebarView: 'messages', checkpoint: null }));
	}, [app.size.md, projectId]);

	// Render
	return <ProjectLayoutContext.Provider value={{ options, setOptions }}>{children}</ProjectLayoutContext.Provider>;
};

const useProjectLayout = () => {
	return React.useContext(ProjectLayoutContext);
};

export {
	PROJECT_SIDEBAR_COLLAPSED_WIDTH,
	PROJECT_SIDEBAR_SNAP_WIDTH,
	PROJECT_SIDEBAR_WIDTH,
	ProjectLayoutProvider,
	useProjectLayout,
};
